import { lazyRemoteModule } from '@space-shell/lib/runtime'

export const useUserProfileEvents = () => {
  const onOpen = async (userUcode?: string, componentName?: string) => {
    const remoteModule = await lazyRemoteModule<
      () => { onOpen: (ucode?: string, componentName?: string) => void }
    >('community/useUserProfileEvents')

    remoteModule?.()?.onOpen(userUcode, componentName)
  }

  const onOpenProfile = (
    event: React.MouseEvent | React.KeyboardEvent,
    userUcode?: string,
    componentName?: string
  ) => {
    const isKeyboardEvent = typeof event === 'object' && 'key' in event

    if (!isKeyboardEvent || (isKeyboardEvent && event.key === 'Enter')) {
      onOpen(userUcode, componentName)
    }
  }

  return {
    onOpenProfile
  }
}
